import React, { useEffect, useState } from 'react';

import { ThumbnailViewer } from '../ThumbnailViewer/ThumbnailViewer';

import * as S from './styles';
import { PdfPageStateProps } from 'components/ListDocumentsViewer/utils/interfaces';
import { Checkbox } from '@material-ui/core';
import { ButtonTheme } from 'modules/financing/components/atoms/NewFinancingButton/styles';
interface SidebarProps {
  documents?: { id: number; documentUrl: string }[];
  handlePdfRender: ({ idPdf }: { idPdf: number }) => void;
  pdfRenderId?: number;
  handleDownloadDocuments?: ({
    documentIds,
  }: {
    documentIds: number[];
  }) => void;
  isLoadingDownload?: boolean;
  listDocumentsViewerState: PdfPageStateProps;
  setListDocumentsViewerState: React.Dispatch<
    React.SetStateAction<PdfPageStateProps>
  >;
}

export const Sidebar = ({
  documents = [],
  handlePdfRender,
  pdfRenderId,
  handleDownloadDocuments,
  isLoadingDownload = false,
  listDocumentsViewerState,
  setListDocumentsViewerState,
}: SidebarProps) => {
  const [selectedDocs, setSelectedDocs] = useState<number[]>([]);

  const downloadClicked = listDocumentsViewerState?.downloadClicked;

  const handleCheckboxChange = (id: number) => {
    setSelectedDocs(prev =>
      prev.includes(id) ? prev.filter(docId => docId !== id) : [...prev, id]
    );
  };

  const handleDownload = async () => {
    await handleDownloadDocuments?.({ documentIds: selectedDocs });
    setSelectedDocs([]);
    setListDocumentsViewerState(prev => ({
      ...prev,
      downloadClicked: false,
    }));
  };

  useEffect(() => {
    if (!downloadClicked) {
      setSelectedDocs([]);
    }
  }, [downloadClicked]);

  return (
    <S.Container>
      {downloadClicked && (
        <S.TypographyCustom>Selecione os documentos:</S.TypographyCustom>
      )}
      <S.ContainerDocuments>
        {documents?.map((doc, index) => {
          const isFirst = index === 0;

          return (
            <S.ContainerCheckboxAndDocument key={doc?.id}>
              {downloadClicked && (
                <Checkbox
                  checked={selectedDocs.includes(doc?.id)}
                  onChange={() => handleCheckboxChange(doc?.id)}
                  disabled={isLoadingDownload}
                />
              )}
              <S.DocumentWrapper
                data-is-first={isFirst}
                data-actived-border={pdfRenderId === doc?.id}
                onClick={() => handlePdfRender({ idPdf: doc?.id })}
              >
                <ThumbnailViewer fileUrl={doc?.documentUrl} />
              </S.DocumentWrapper>
            </S.ContainerCheckboxAndDocument>
          );
        })}
      </S.ContainerDocuments>
      {!!downloadClicked && (
        <S.ButtonWrapper>
          <ButtonTheme disabled={!selectedDocs.length} onClick={handleDownload}>
            Baixar
          </ButtonTheme>
        </S.ButtonWrapper>
      )}
    </S.Container>
  );
};
